module.exports = __webpack_public_path__ + "img/yo.a9348c65.jpg";